module.exports = __webpack_public_path__ + "static/media/patton_stokes.6e7fcb66.jpg";